import { deepTransformDate, deepTransformTimestamp } from '../../utils/date';
import { Uuid } from '../Base';
import { RepositoryElement } from '../Repository';
import { CashBalance, CashBalanceJson } from '../UserStore/Account';

export enum ReferralSystem {
  SmartParentsPlan = 'smartParentsPlan',
  WeaMembershipPlan = 'weaMembershipPlan',
}

export interface RewardReferralJson<T = number> {
  userId: Uuid;
  referralSystem: ReferralSystem;
  referredBy: Uuid;
  referredAt: T;
  lastPurchasedAt?: T;
  tier1Reward: CashBalanceJson;
  tier2Reward: CashBalanceJson;

  rewardReferralCode?: RewardReferralCode;
}

export class RewardReferral
  extends RepositoryElement
  implements RewardReferralJson<Date>
{
  userId!: Uuid;
  referralSystem!: ReferralSystem;
  referredBy!: Uuid;
  referredAt!: Date;
  lastPurchasedAt?: Date;
  tier1Reward!: CashBalance;
  tier2Reward!: CashBalance;

  rewardReferralCode?: RewardReferralCode;

  constructor(rewardReferral: RewardReferralJson<Date | number>) {
    super();
    const { tier1Reward, tier2Reward, ...rest } = deepTransformTimestamp(
      rewardReferral,
    ) as RewardReferralJson<Date>;
    this.tier1Reward = new CashBalance(tier1Reward);
    this.tier2Reward = new CashBalance(tier2Reward);
    Object.assign(this, rest);
  }

  id() {
    return `${this.referralSystem}_${this.userId}`;
  }

  toJSON(): RewardReferralJson {
    return deepTransformDate(this) as unknown as RewardReferralJson;
  }
}

export interface RewardReferralCode {
  referralCode: string; // 12 digit
  userId: Uuid;
  referralSystem: ReferralSystem;
}
